<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="10">
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">裁判功能</span>
            </el-col>
          </el-row>
          <div class="button-container">
            <el-button type="warning" size="small" @click="getExamQuestion()">获取考题</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-link" @click="copyFn('semiWelcome')" >大屏欢迎页</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-link" @click="copyFn('semiRank')">大屏排名</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :span="14">
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">选择考场</span>
            </el-col>
          </el-row>
          <el-form
            :model="queryForm"
            class="filter_Form"
            label-width="60px"
            ref="queryFormRef"
          >
            <el-row>
              <el-col :span="8">
                <el-form-item label="赛季" prop="season" style="margin-bottom: 0;">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.season"
                    @change="changeFn"
                  >
                    <el-option
                      v-for="item in dict_season"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="赛程" prop="raceSchedule">
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="queryForm.raceSchedule"
                    @change="changeFn"
                  >
                    <el-option
                      v-for="item in dict_matchType"
                      :key="item.id"
                      :label="item.scheduleName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="赛区" prop="districtId">
                  <el-select
                    placeholder="请选择"
                    filterable
                    style="width: 100%"
                    v-model="queryForm.districtId"
                    @change="changeFn"
                  >
                    <el-option
                      v-for="item in dict_district"
                      :key="item.id"
                      :label="item.districtName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="考场" prop="examRoomId" >
                  <el-select
                    placeholder="请选择"
                    style="width: 100%"
                    v-model="examRoomId"
                    filterable
                    @change="examRoomChange"
                  >
                    <el-option
                      v-for="(item,index) in examRooms"
                      :key="index"
                      :label="item.roomName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="4" style="text-align: right;">
                <el-button type="primary" @click="getList">查 询</el-button>
              </el-col> -->
            </el-row>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">比赛信息
            <el-tag style="margin-left: 12px;" :type="matchEndType === 1 ? 'success' : matchEndType === 2 ? 'error' : ''">
              {{ matchEndType === 1 ? '进行中' : matchEndType === 2 ? '已结束' : '未开始' }}
            </el-tag>
            <i class="refresh" :class="isLoading ? 'el-icon-loading' : 'el-icon-refresh'" @click="getList"></i>
            <span class="tips">比赛进行中，请勿刷新页面</span>
          </span>
        </el-col>
        <el-col :span="12" align="right">
          <span class="tips" v-if="show2Min">比赛剩余时间：</span>
          <span class="timer" v-if="show2Min" style="margin-left: 0;margin-right: 20px; color: #F56C6C;">{{ timeStr2 }}</span>
          <el-button type="danger" @click="endFn" :disabled="matchEndType === 2">本场比赛结束</el-button>
          <el-button type="warning" plain @click="reset">重置比赛状态</el-button>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        :row-class-name="tableRowClassName"
        border
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="题号" prop="quizNumber" width="47"></el-table-column>
        <el-table-column label="题目类型" prop="quizForm">
          <template slot-scope="scope">
            <el-tag size="mini" :effect="scope.row.quizForm === 1 ? 'dark' : 'light'">{{ scope.row.quizForm === 1 ? '例题' : '试题' }} </el-tag>
            <el-tag v-if="scope.row.isStandby" size="mini" type="warning" style="margin-left: 10px;">(备用)</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="题型" prop="quizType">
          <template slot-scope="scope">
            <el-tag :type="scope.row.quizType === 1 ? 'warning' : scope.row.quizType === 2 ? 'success' : 'danger'">
              {{ formatQuizType(scope.row.quizType) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="选项" prop="choice" :width="260">
          <template slot-scope="scope">
            <template v-if="scope.row.choiceType === 2">
              <span class="choice-text" v-for="(font, index) of scope.row.choiceList" :key="index">{{ font }}</span>
            </template>
            <template v-else>
              <div class="choice-img" v-for="(img, index) of scope.row.choiceList" :key="index">
                <img :src="img" alt="">
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="答案" prop="answer">
          <template slot-scope="scope">
            <div style="display: flex; align-items: center;">
              <div v-for="(a, aIndex) of scope.row.answerList" :key="aIndex">
                <div class="choice-img" v-if="a.length > 5">
                  <img :src="a" class=""/>
                </div>
                <span v-else class="choice-text">{{ a }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="分数" prop="questionScore"></el-table-column> -->
        <el-table-column label="状态" prop="">
          <template slot-scope="scope">
            <el-tag v-if="matchEndType === 2" size="mini">已结束</el-tag>
            <el-tag size="mini" type="info" v-else-if="matchEndType !== 1 && matchEndType  !== 2">未作答</el-tag>
            <el-tag v-else-if="show2Min" size="mini">作答完成</el-tag>
            <template v-else>
              <el-tag v-if="scope.row.usedIng" type="success">正在作答</el-tag>
              <div class="timer" v-if="scope.row.usedIng">{{ timeStr }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="是否使用" width="100">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.isUsed"
              type="success"
              size="mini"
              >是</el-tag>
            <el-tag
              v-else
              type="info"
              size="mini"
              >否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否作废" width="100">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.isDiscard"
              type="danger"
              size="mini"
              >是</el-tag>
            <el-tag
              v-else
              type="info"
              size="mini"
              >否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              :disabled="matchEndType === 2"
              @click="startFn(scope)"
            >开始作答</el-button>
            <el-button
              type="warning"
              size="mini"
              :disabled="matchEndType === 2 || !scope.row.audioUrl"
              @click="toggleAudio(scope)"
            >{{ isAudioPlaying(scope.row) ? '暂停音频' : '播放音频' }}</el-button>
            <el-button
              type="danger"
              size="mini"
              :disabled="matchEndType === 2"
              @click="cancellation(scope)"
            >作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer-tips">
        <span class="tips" v-if="show2Min">比赛剩余时间：</span>
        <span class="timer" v-if="show2Min" style="margin-left: 0;margin-right: 20px; color: #F56C6C;">{{ timeStr2 }}</span>
      </div>
    </el-card>
  </div>
</template>
<script>
import { queryDistrictPage } from '@/http/api'

export default {
  data () {
    return {
      examRoomId: '',
      examRooms: [], // 考场下拉列表
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }), // 赛季下拉列表
      dict_matchType: [], // 赛程下拉列表
      dict_district: [], // 赛区下拉列表
      examRoomInfo: {}, // 考场信息
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        raceSchedule: '2'
      },
      dataList: [],
      quizTypeList: ['题型A', '题型B', '题型C'],
      matchEndType: 0,
      isLoading: false,
      timer: null,
      timeStr: '00:00',
      lastQuiz: false, // 标记是否最后一题，最后一题倒计时结束后，开始2min倒计时
      timer2: null,
      timeStr2: '00:00',
      show2Min: false,
      audioPlayer: null,
      currentAudioRowId: null,
      audioStatus: 'stopped'
    }
  },
  methods: {
    tableRowClassName ({ row }) {
      if (row.isDiscard) {
        return 'discarded'
      }
      if (row.isStandby) {
        return 'standby'
      }
      if (row.usedIng) {
        return 'usedIng'
      }
      return ''
    },
    init3B () {
      this.show2Min = false
      this.lastQuiz = false
      this.level = ''
      const params = this.$route.query
      console.log('init3B', params)
      if (params.id) {
        this.phase = params.phase || '1'
        this.queryForm.season = params.s
        this.queryForm.districtId = params.d
        this.examRoomId = params.id
      }
      // 赛程--默认传入复赛 2 写死的
      this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(value => {
        this.dict_matchType = value
      })
      // 赛区--不传入默认取全国非
      this.getDistrictList(params.d)
    },
    // 获取赛区筛选数据
    getDistrictList (districtId) {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
        // this.queryForm.districtId = districtId || this.dict_district[1].id
        this.getExamRoomSelect()
      }).catch((err) => {
        console.log('err', err)
      })
    },
    getExamQuestion () {
      this.$http.post('examinationUser/copyRoundOneGroupForm', {
        id: this.examRoomId,
        phase: this.phase
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('第一轮考题已生成')
          this.getList()
        }
      })
    },
    copyFn (type) {
      var loc = window.location.origin
      var input = document.createElement('input') // 创建input标签
      if (!this.examRoomId) return this.$message.warning('请选择考场')
      const query = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        raceSchedule: this.queryForm.raceSchedule,
        phase: this.phase,
        examinationRoomId: this.examRoomId,
        isShowScore: 1
      }
      if (type === 'semiWelcome') {
        query.round2026 = 1
      }

      input.value = `${loc}/#/${type}?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    },
    // 获取考场列表
    getExamRoomSelect () {
      this.$http.get('examination/queryExaminationList', { params: this.queryForm }).then(res => {
        this.examRooms = res.data
        if (this.examRoomId) {
          // 路径带入，直接获取信息
          this.examRoomInfo = res.data.find(item => item.id === this.examRoomId)
          this.getList()
        }
      })
    },
    changeFn () {
      this.examRoomId = ''
      this.getExamRoomSelect()
    },
    getStatus () {
      this.$http.get('examinationUser/getProgress?id=' + this.examRoomId).then(res => {
        if (res.code === 200) {
          this.matchEndType = res.data ? res.data.matchEndType : 0
        }
      })
    },
    // 切换考场
    examRoomChange (e) {
      // 修改考场信息
      this.examRoomInfo = this.examRooms.find(item => item.id === this.examRoomId)
      // 获取考生列表
      this.getList()
    },
    getList () {
      this.isLoading = true
      this.$http.get('/examinationUser/getQuestionById', { params: { id: this.examRoomId } }).then(res => {
        if (res.code === 200) {
          this.getStatus()
          this.dataList = res.data
          this.dataList.forEach(item => {
            // 选项
            if (item.choice.includes('http')) {
              item.choiceType = 1
            } else {
              item.choiceType = 2
            }
            item.choiceList = item.choice.split(',')
            // 答案
            item.answerList = item.answer.split(',')
          })
          this.currentIndex = this.dataList.findIndex(item => item.usedIng)
        }
        this.isLoading = false
      })
    },
    startFn (scope) {
      this.show2Min = false
      this.stop2MinCountdown()
      this.lastQuiz = scope.$index === this.dataList.length - 1
      this.stopCountdown()
      // console.log(scope.$index)
      const data = {
        examinationId: this.examRoomId,
        matchEndType: 1, // "比赛结束状态 1:比赛中 2:已结束"
        index: scope.$index + 1,
        questionId: scope.row.id
      }
      this.$http.post('examinationUser/setProgress', data).then(res => {
        if (res.code === 200) {
          this.getList()
          const quizTime = Math.floor((res.data.endTime - new Date().getTime()) / 1000)
          this.timeStr = this.$xcUtils.sec2time(quizTime)
          if (quizTime > 0) {
            this.startCountdown(quizTime)
          }
        }
      })
    },

    endFn () {
      this.$confirm('强制交卷，结束本场比赛', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.stopCountdown()
        const data = {
          examinationId: this.examRoomId,
          matchEndType: 2
        }
        this.$http.post('examinationUser/setProgress', data).then(res => {
          if (res.code === 200) {
            this.getStatus()
            this.$message.success('本场比赛结束')
            this.show2Min = false
            this.lastQuiz = false
            this.stopCountdown()
            this.stop2MinCountdown()
          }
        })
      }).catch(() => {
      })
    },
    reset () {
      this.$confirm('将比赛状态重置为“未开始”，请谨慎操作', '确认重置？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.stopCountdown()
        const data = {
          examinationId: this.examRoomId,
          matchEndType: 0,
          index: null,
          questionId: null
        }
        this.$http.post('examinationUser/setProgress', data).then(res => {
          if (res.code === 200) {
            this.getList()
            this.$message.success('已重置')
            this.show2Min = false
            this.lastQuiz = false
            this.stopCountdown()
            this.stop2MinCountdown()
          }
        })
      }).catch(() => {
      })
    },
    startCountdown (quizTime) {
      this.timer = setInterval(() => {
        quizTime--
        console.log(quizTime)
        if (quizTime > 0) {
          this.timeStr = this.$xcUtils.sec2time(quizTime)
        } else {
          this.timeStr = '00:00'
          this.stopCountdown()
          if (this.lastQuiz) {
            this.show2Min = true
            this.timeStr2 = this.$xcUtils.sec2time(120)
            this.start2MinCountdown()
          }
        }
      }, 1000)
    },
    stopCountdown () {
      clearInterval(this.timer)
      this.timer = null
    },

    start2MinCountdown () {
      let quizTime = 120
      this.timer2 = setInterval(() => {
        quizTime--
        if (quizTime > 0) {
          this.timeStr2 = this.$xcUtils.sec2time(quizTime)
        } else {
          this.timeStr2 = '00:00'
          this.stop2MinCountdown()
        }
      }, 1000)
    },
    stop2MinCountdown () {
      clearInterval(this.timer2)
      this.timer2 = null
    },
    formatQuizType (quizType) {
      return quizType ? this.quizTypeList[quizType - 1] : ''
    },

    cancellation (scope) {
      console.log(scope)
      this.$confirm('是否确认作废该题目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          examinationId: this.examRoomId,
          matchEndType: 3,
          index: scope.$index + 1,
          questionId: scope.row.id
        }
        this.$http.post('examinationUser/setProgress', data).then(res => {
          if (res.code === 200) {
            this.stopCountdown()
            this.$message.success('作废成功')
            this.getList()
          }
        })
      }).catch(() => {
        // 用户取消操作
      })
    },
    playAudio (scope) {
      const { id, audioUrl } = scope.row
      if (!audioUrl) {
        this.$message.warning('当前题目暂无音频')
        return
      }

      if (this.currentAudioRowId === id && this.audioPlayer) {
        if (this.audioStatus === 'paused') {
          this.$confirm('请选择播放方式', '播放音频', {
            confirmButtonText: '重新播放',
            cancelButtonText: '继续播放',
            distinguishCancelAndClose: true,
            type: 'info'
          }).then(() => {
            this.playCurrentAudio(true)
          }).catch((action) => {
            if (action === 'cancel') {
              this.playCurrentAudio(false)
            }
          })
          return
        }
        this.playCurrentAudio(false)
        return
      }

      this.stopAudio()
      this.audioPlayer = new Audio(audioUrl)
      this.currentAudioRowId = id
      this.audioStatus = 'stopped'
      this.audioPlayer.onplay = () => {
        this.audioStatus = 'playing'
      }
      this.audioPlayer.onpause = () => {
        if (this.audioPlayer && this.audioPlayer.ended) return
        this.audioStatus = 'paused'
      }
      this.audioPlayer.onended = () => {
        this.resetAudioState()
      }
      this.audioPlayer.onerror = () => {
        this.$message.error('音频播放失败')
        this.resetAudioState()
      }
      this.playCurrentAudio(true)
    },
    playCurrentAudio (restart) {
      if (!this.audioPlayer) return
      if (restart) {
        this.audioPlayer.currentTime = 0
      }
      const playPromise = this.audioPlayer.play()
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {
          this.$message.error('音频播放失败')
          this.resetAudioState()
        })
      }
    },
    toggleAudio (scope) {
      if (this.isAudioPlaying(scope.row)) {
        this.pauseAudio(scope)
      } else {
        this.playAudio(scope)
      }
    },
    isAudioPlaying (row) {
      return this.audioStatus === 'playing' && this.currentAudioRowId === row.id
    },
    pauseAudio (scope) {
      if (!scope || !scope.row) return
      if (
        this.audioPlayer &&
        this.currentAudioRowId === scope.row.id &&
        this.audioStatus === 'playing'
      ) {
        this.audioPlayer.pause()
      }
    },
    stopAudio () {
      if (!this.audioPlayer) {
        this.resetAudioState()
        return
      }
      this.audioPlayer.onplay = null
      this.audioPlayer.onpause = null
      this.audioPlayer.onended = null
      this.audioPlayer.onerror = null
      this.audioPlayer.pause()
      this.audioPlayer.currentTime = 0
      this.resetAudioState()
    },
    resetAudioState () {
      this.audioPlayer = null
      this.currentAudioRowId = null
      this.audioStatus = 'stopped'
    },
    beforeDestroy () {
      this.stopCountdown()
      this.stop2MinCountdown()
      this.stopAudio()
    }
  }
}
</script>
<style lang="less" scoped>
.choice-text{
  display: block;
  float: left;
  min-width: 20px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  margin: 4px;
  border: 1px solid #409EFF;
  border-radius: 4px;
  font-size: 14px;
  color: #000;
  padding-left: 2px;
  padding-right: 2px;
}
.choice-img{
  width: 32px;
  height: 32px;
  padding-top: 1px;
  margin-right: 8px;
  border: 1px solid #409EFF;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  img{
    height: 28px;
    width: auto;
  }
}
::v-deep .el-table .usedIng {
    background: #e6f3ff;
}
::v-deep .el-table .discarded {
    background: #fde2e2;
}
::v-deep .el-table .standby {
    background: #f7e7d3;
}
.refresh{
  color: #409EFF;
  cursor: pointer;
  margin-left: 12px;
}
.timer{
  font-size: 16px;
  font-weight: bold;
  margin-left: 12px;
  color: #67c23a;
}
.tips{
  font-size: 12px;
  color: #606266;
  margin-left: 12px;
}
.footer-tips{
  text-align: center;
  margin-top: 20px;
  height: 30px;
}
.button-container{
  min-height: 62px;
}
</style>
